"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tablet = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Tablet = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.4 0h14.4a2.4 2.4 0 012.4 2.4v19.2a2.4 2.4 0 01-2.4 2.4H4.4A2.4 2.4 0 012 21.6V2.4A2.4 2.4 0 014.4 0zm0 20.4h14.4v-18H4.4v18z", clipRule: "evenodd" })); };
exports.Tablet = Tablet;
//# sourceMappingURL=tablet.js.map